var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.GenericAvatar,{attrs:{"variant":_vm.variant,"size":_vm.size,"avatar":_vm.user.avatar,"label":_setup.capitalize(_vm.user.full_name)}})
}
var staticRenderFns = []

export { render, staticRenderFns }